// Auth uç noktaları (mobildeki AuthRepository'nin web karşılığı).
// Tüm fonksiyonlar zarfı açıp ham veriyi döner; hata durumunda ApiError fırlatır.

import api from '../../api/client';
import { unwrap, toApiError } from '../../api/unwrap';

// POST /auth/login → { accessToken, refreshToken }
export const login = async ({ emailOrPhone, password }) => {
  try {
    const response = await api.post('/auth/login', { emailOrPhone, password });
    return unwrap(response); // { accessToken, refreshToken }
  } catch (error) {
    throw toApiError(error);
  }
};

// POST /auth/register → { token, refreshToken, verifyRequest? }
export const register = async ({ email, fullName, password }) => {
  try {
    const response = await api.post('/auth/register', {
      email,
      fullName,
      password,
    });
    return unwrap(response); // { token, refreshToken, verifyRequest? }
  } catch (error) {
    throw toApiError(error);
  }
};

// POST /auth/verify → { email, code }. Başarıda 200, hatada 400 (error mesajı).
export const verifyEmail = async ({ email, code }) => {
  try {
    await api.post('/auth/verify', { email, code });
    return true;
  } catch (error) {
    throw toApiError(error);
  }
};

// POST /auth/resendCode → { email } → { verifyRequest } (429 rate limit)
export const resendCode = async (email) => {
  try {
    const response = await api.post('/auth/resendCode', { email });
    return unwrap(response); // { verifyRequest: { email, sessionTimeOut, ... } }
  } catch (error) {
    throw toApiError(error);
  }
};
